import { FC, useCallback, useLayoutEffect, useState } from "react"
import { Button, Select } from "@unlimint/admin-ui-kit"
import { useContextSelector as useCS } from "use-context-selector"

import { ReportTypeEnum } from "domain/reports/enums"
import { useCreateReport } from "domain/reports/hooks/useCreateReport"
import { TFetchListParamReq } from "domain/core/types"
import { GridStateStorageService } from "domain/core/services/GridStateStorageService"
import { UserContext } from "domain/user/UserContext"
import { userSelectors } from "domain/user/selectors"

import { downloadBtnState } from "./utils"
import * as S from "./styled"

const fileTypeOptions = [
  {
    value: ReportTypeEnum.CSV,
    label: "CSV",
  },
  {
    value: ReportTypeEnum.XLSX,
    label: "XLSX",
  },
]

type TDownloadReportButtonProps = {
  name: string
  url: string
  fileName: string
  params?: TFetchListParamReq
}

export const DownloadReportButton: FC<TDownloadReportButtonProps> = ({
  name,
  url,
  fileName,
  params,
}) => {
  const userId: string = useCS(UserContext, userSelectors.userId)

  const [stateService, setStateService] = useState(null)
  const [type, setType] = useState(null)

  const { status, send } = useCreateReport({
    key: name,
    url,
    params,
    fileLabel: fileName,
    type,
  })
  const { label, isDisabled } = downloadBtnState(status)

  useLayoutEffect(() => {
    if (!userId) return

    const gridStateStorageService = new GridStateStorageService(
      userId,
      `${name}Report`
    )
    setStateService(gridStateStorageService)
    gridStateStorageService.getState().then((value) => {
      if (value) setType(value)
      else setType(fileTypeOptions[0].value)
    })
  }, [userId])

  const changeTypeHandler = useCallback(
    (e) => {
      const { value } = e.target
      setType(value)
      stateService.update(value)
    },
    [stateService]
  )

  if (!type) return null

  return (
    <>
      <Button size="small" disabled={isDisabled} onClick={send}>
        {label}
      </Button>
      <S.Selector>
        <Select
          options={fileTypeOptions}
          disabled={isDisabled}
          onChange={changeTypeHandler}
          defaultValue={type}
          size="small"
        />
      </S.Selector>
    </>
  )
}
